import * as React from "react";
import { useLocalization } from "@shared-ui/localization-context";
import { PriceLockup } from "components/shared/PriceLockup/PriceLockup";
import { PriceLockupAlign } from "components/shared/PriceLockup/typings";
import { PriceProps } from "../typings";

export const PriceContent = (props: PriceProps) => {
  const { formatText } = useLocalization();

  return (
    <div>
      {!props.isSoldOut ? (
        <PriceLockup
          align={PriceLockupAlign.LEFT}
          lockupPrice={props.priceToShow}
          priceSubtextFirst={props.priceMessage}
          a11yPrice={`${props.priceToShow}`}
        />
      ) : (
        <div className="uitk-type-heading-500 hotelSoldOut">
          <b>{formatText("recentlyViewedHotels.soldOut")}</b>
        </div>
      )}
    </div>
  );
};
